import { makeStyles, styled } from "@material-ui/styles";
import { CollapsableSection, Column } from "lqx-react";
import React from "react";
import {
    FormLabel,
    Input,
} from "lqx-react/lib";
import { ErrorHighligter, asTimelessLinkedDate, DigiDateInput } from "../shared";
import { AssetColumn, numberInputStyles } from "../components/number-input";
import { DigiSelectAsync } from "../components/select-async";
import { getSuppliersAsCommonParticipants, getBuyersAsCommonParticipants, getPayersAsCommonParticipants, getPayeesAsCommonParticipants } from "../api/companyParticipant";
import NumberFormat from "react-number-format";
import { globalStore } from 'api/store';
import { DigiAsyncSelect, DigiCurrencySelect } from "../components/select";
import { hasRole } from "src/app/services/can";
import { RemittanceAdvice } from "../api/remittanceAdvice";

export const EditRemittanceAdviceTab = ({ remittanceAdvice, errors }: { remittanceAdvice: RemittanceAdvice, errors }) => {
    const sectionStyles = SectionStyles();
    const classesNum = numberInputStyles();

    return (<>
        <CollapsableSection title="General" titleClassName={sectionStyles.sectionTitle} noBorder noShadow>
            <Column>
                <FlexStyled>
                    <StyledFormLabel>Payor</StyledFormLabel>
                    <ErrorHighligterStyled error={errors[`payor`]}>
                        <DropDownBlock>
                            <DigiAsyncSelect
                                aria-label="Company Counter Party"
                                data-qa-id={`company payor`}
                                getItems={getPayersAsCommonParticipants}
                                $value={remittanceAdvice.payor.$.company}
                                isCreater={hasRole('AssetFacilitator')}
                            />
                        </DropDownBlock>
                    </ErrorHighligterStyled>
                </FlexStyled>

                <CollapsableSection title="BANK ACCOUNT INFORMATION" titleClassName={sectionStyles.sectionTitle} noBorder noShadow>
                    <Column>
                        <FlexStyled>
                            <StyledFormLabel>Name</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['payor.BankName']}>
                                <StyledInput data-qa-id="bank name" type={'string'} $value={remittanceAdvice.payor.$.bankName} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Alias</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['payor.BankAlias']}>
                                <StyledInput data-qa-id="bank alias" type={'string'} $value={remittanceAdvice.payor.$.bankAlias} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Account Number</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['payor.BankAccountNumber']}>
                                <StyledInput data-qa-id="bank account number" type={'string'} $value={remittanceAdvice.payor.$.bankAccountNumber} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Branch Code</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['payor.BankBranchCode']}>
                                <StyledInput data-qa-id="bank branch code" type={'string'} $value={remittanceAdvice.payor.$.bankBranchCode} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                    </Column>
                </CollapsableSection>

                <FlexStyled>
                    <StyledFormLabel>Payee</StyledFormLabel>
                    <ErrorHighligterStyled error={errors[`payee`]}>
                        <DropDownBlock>
                            <DigiAsyncSelect
                                aria-label="Company Counter Party"
                                data-qa-id={`company payee`}
                                getItems={getPayeesAsCommonParticipants}
                                $value={remittanceAdvice.payee.$.company}
                                isCreater={hasRole('AssetFacilitator')}
                            />
                        </DropDownBlock>
                    </ErrorHighligterStyled>
                </FlexStyled>

                <CollapsableSection title="BANK ACCOUNT INFORMATION" titleClassName={sectionStyles.sectionTitle} noBorder noShadow>
                    <Column>
                        <FlexStyled>
                            <StyledFormLabel>Name</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['payee.BankName']}>
                                <StyledInput data-qa-id="bank name" type={'string'} $value={remittanceAdvice.payee.$.bankName} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Alias</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['payee.BankAlias']}>
                                <StyledInput data-qa-id="bank alias" type={'string'} $value={remittanceAdvice.payee.$.bankAlias} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Account Number</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['payee.BankAccountNumber']}>
                                <StyledInput data-qa-id="bank account number" type={'string'} $value={remittanceAdvice.payee.$.bankAccountNumber} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Branch Code</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['payee.BankBranchCode']}>
                                <StyledInput data-qa-id="bank branch code" type={'string'} $value={remittanceAdvice.payee.$.bankBranchCode} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                    </Column>
                </CollapsableSection>

                <FlexStyled>
                    <StyledFormLabel>Payment Date</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['paymentDate']}>
                        <DigiDateWrapper>
                            <DigiDateInputStyled data-qa-id="payment date" date $value={asTimelessLinkedDate(remittanceAdvice.$.paymentDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>

                <FlexStyled>
                    <StyledFormLabel>Payment Currency</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['paymentCurrency']}>
                        <InputWrraper>
                            <DigiCurrencySelect
                                isMulti={false}
                                options={globalStore.currenciesLookup.items.models}
                                $value={remittanceAdvice.$.paymentCurrency}
                            />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>

                <FlexStyled>
                    <StyledFormLabel>Payment Amount</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['paymentAmount']}>
                        <InputWrraper>
                            <NumberFormatStyled
                                data-qa-id="payment amount"
                                value={remittanceAdvice.$.paymentAmount.value}
                                className={classesNum.numericInput}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                onValueChange={(values) => { const { floatValue } = values; remittanceAdvice.$.paymentAmount.set(floatValue) }}
                            />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>

                <FlexStyled>
                    <StyledFormLabel>Payment Reference Number</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['paymentReferenceNumber']}>
                        <StyledInput data-qa-id="payment reference number" type={'string'} $value={remittanceAdvice.$.paymentReferenceNumber} />
                    </ErrorHighligterStyled>
                </FlexStyled>

                <FlexStyled>
                    <StyledFormLabel>Relationship Id</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['relationShipId']}>
                        <StyledInput data-qa-id="relationship id" type={'string'} $value={remittanceAdvice.$.relationShipId} />
                    </ErrorHighligterStyled>
                </FlexStyled>

                <CollapsableSection title="INVOICE INFORMATION" titleClassName={sectionStyles.sectionTitle} noBorder noShadow>
                    <Column>
                        <FlexStyled>
                            <StyledFormLabel>Invoice Number</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.Number']}>
                                <StyledInput data-qa-id="invoice number" type={'string'} $value={remittanceAdvice.invoice.$.number} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Supplier Name</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.Supplier']}>
                                <DigiSelectAsync
                                    data-qa-id={"supplier"}
                                    getItems={getSuppliersAsCommonParticipants}
                                    $value={remittanceAdvice.invoice.$.supplier}
                                    styles={{ minWidth: '350px' }}
                                />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Buyer Name</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.Buyer']}>
                                <DigiSelectAsync
                                    data-qa-id={"buyer"}
                                    getItems={getBuyersAsCommonParticipants}
                                    $value={remittanceAdvice.invoice.$.buyer}
                                    styles={{ minWidth: '350px' }}
                                />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Invoice Date</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.InvoiceDate']}>
                                <DigiDateWrapper>
                                    <DigiDateInputStyled data-qa-id="invoice date" date $value={asTimelessLinkedDate(remittanceAdvice.invoice.$.invoiceDate)} />
                                </DigiDateWrapper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Invoice Due Date</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.InvoiceDueDate']}>
                                <DigiDateWrapper>
                                    <DigiDateInputStyled data-qa-id="invoice due date" date $value={asTimelessLinkedDate(remittanceAdvice.invoice.$.invoiceDueDate)} />
                                </DigiDateWrapper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Face Value</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.FaceValue']}>
                                <InputWrraper>
                                    <NumberFormatStyled
                                        data-qa-id="face value"
                                        value={remittanceAdvice.invoice.$.faceValue.value}
                                        className={classesNum.numericInput}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                        onValueChange={(values) => { const { floatValue } = values; remittanceAdvice.invoice.$.faceValue.set(floatValue) }}
                                    />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Currency</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.Currency']}>
                                <InputWrraper>
                                    <DigiCurrencySelect
                                        isMulti={false}
                                        options={globalStore.currenciesLookup.items.models}
                                        $value={remittanceAdvice.invoice.$.currency}
                                    />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Discount</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.Discount']}>
                                <InputWrraper>
                                    <NumberFormatStyled
                                        data-qa-id="discount"
                                        value={remittanceAdvice.invoice.$.discount.value}
                                        className={classesNum.numericInput}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                        onValueChange={(values) => { const { floatValue } = values; remittanceAdvice.invoice.$.discount.set(floatValue) }}
                                    />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Net Amount</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.NetAmount']}>
                                <InputWrraper>
                                    <NumberFormatStyled
                                        data-qa-id="net amount"
                                        value={remittanceAdvice.invoice.$.netAmount.value}
                                        className={classesNum.numericInput}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                        onValueChange={(values) => { const { floatValue } = values; remittanceAdvice.invoice.$.netAmount.set(floatValue) }}
                                    />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Applied Amount</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.AppliedAmount']}>
                                <InputWrraper>
                                    <NumberFormatStyled
                                        data-qa-id="applied amount"
                                        value={remittanceAdvice.invoice.$.appliedAmount.value}
                                        className={classesNum.numericInput}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                        onValueChange={(values) => { const { floatValue } = values; remittanceAdvice.invoice.$.appliedAmount.set(floatValue) }}
                                    />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Write Off</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.WriteOff']}>
                                <InputWrraper>
                                    <NumberFormatStyled
                                        data-qa-id="write off"
                                        value={remittanceAdvice.invoice.$.writeOff.value}
                                        className={classesNum.numericInput}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                        onValueChange={(values) => { const { floatValue } = values; remittanceAdvice.invoice.$.writeOff.set(floatValue) }}
                                    />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Details</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['invoice.Details']}>
                                <StyledInput data-qa-id="details" type={'string'} $value={remittanceAdvice.invoice.$.details} />
                            </ErrorHighligterStyled>
                        </FlexStyled>
                    </Column>
                </CollapsableSection>
            </Column>
        </CollapsableSection>
    </>)
}

const SectionStyles = makeStyles({
    sectionTitle: {
        color: '#63a9dc',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center'
    }
})

const ErrorHighligterStyled = styled(ErrorHighligter)({
    minWidth: '350px !important',
})

const NumberFormatStyled = styled(NumberFormat)({
    width: '350px !important',
})

const InputWrraper = styled('div')({
    width: '100%',
    height: '34px',
    maxWidth: '350px',
    '& input': {
        height: '34px'
    }
})

const FunderWrraper = styled('div')({
    width: '100%',
    maxWidth: '350px',
})

const DropDownBlock = styled('div')({
    width: '350px'
})

const FlexStyled = styled(AssetColumn)({
    width: '100%',
    height: '34px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '8px',
    marginLeft: 0,
    marginRight: 0,
})

const StyledFormLabel = styled(FormLabel)({
    color: '#767D84',
    display: 'flex',
    fontSize: '12px',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    maxWidth: '300px'
})

const StyledInput = styled(Input)({
    marginTop: 4,
    marginBottom: 4,
    height: 32,
    width: '350px'
})

const DigiDateWrapper = styled('div')({
    '& .react-datepicker-wrapper': {
        width: '350px',
        height: '34px',
    },
    '& input': {
        maxWidth: '350px',
        height: '34px',
    }
})

const DigiDateInputStyled = styled(DigiDateInput)({
    width: '350px',
})
